import * as React from 'react';
import { useTheme } from '../../providers/ThemeProvider';
import { Dropdown } from './dropdown';
import { SunIcon, MoonIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline';
import { Button } from './button';

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const Icon = resolvedTheme === 'dark' ? MoonIcon : SunIcon;
  return (
    <Dropdown
      trigger={
        <Button variant="ghost" size="icon" aria-label="Toggle theme">
          <Icon className="h-4 w-4" />
        </Button>
      }
      items={[
        { label: 'Light', icon: <SunIcon />, onSelect: () => setTheme('light') },
        { label: 'Dark', icon: <MoonIcon />, onSelect: () => setTheme('dark') },
        { label: 'System', icon: <ComputerDesktopIcon />, onSelect: () => setTheme('system') },
      ]}
      align="right"
    />
  );
}
